import React from 'react';
import { loader } from 'graphql.macro';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { RouteComponentProps, useParams } from '@reach/router';
import { DocumentsInfoPage } from './DocumentsInfoPage';
import { GET_DOCUMENTS_FROM_PC_getDocumentsFromPC_documentsList as account_documents_item } from './graphql/__generated__/GET_DOCUMENTS_FROM_PC';
import { Box } from 'grommet';
import b64toBlobURL from '../../util/createBase64BlobURL';

const get_account_documents = loader('./graphql/Get_Documents_From_PC.graphql');
const get_policies_by_account = loader(
  './graphql/Get_Policies_By_Account.graphql'
);
const get_document_by_docid = loader('./graphql/Get_Document_By_Id.graphql');

export interface GET_POLICIES_BY_ACCOUNT_account_items_policies_items {
  __typename: 'Policy';
  policy_type: string | null;
  policy_number: string | null;
  expiration_date: any | null;
}

export default (_: RouteComponentProps) => {
  const { accountNumber } = useParams();
  let items: account_documents_item[] | [] = [];
  const { data, loading, error } = useQuery(get_account_documents, {
    variables: {
      account_number: accountNumber
    },
    fetchPolicy: 'network-only'
  });
  if (data) {
    items = data?.getDocumentsFromPC?.documentsList || [];
  }
  let policies:
    | GET_POLICIES_BY_ACCOUNT_account_items_policies_items[]
    | [] = [];
  const { data: policyList } = useQuery(get_policies_by_account, {
    variables: {
      account_number: accountNumber
    },
    fetchPolicy: 'network-only'
  });
  if (policyList) {
    policies = policyList?.getPoliciesByAccount?.PoliciesList || [];
  }

  const download = (contents: string) => {
    setTimeout(() => {
      const newWindow = window.open('about:blank');
      const newTab =
        newWindow &&
        newWindow.document.body.appendChild(
          newWindow.document.createElement('iframe')
        );
      if (newTab) {
        newTab.width = '100%';
        newTab.height = '100%';
        newTab.setAttribute('style', 'border: 0');
        newTab.src = contents;
      }
    }, 0);
  };

  const openHtmlContent = (content: string) => {
    try {
      let htmlString = content;

      if (
        /^([A-Za-z0-9+/=]+\s*)+$/.test(content) ||
        content.startsWith('data:')
      ) {
        const cleanBase64 = content.replace(/^data:.*;base64,/, '');
        htmlString = atob(cleanBase64);
      }

      const blob = new Blob([htmlString], { type: 'text/html' });
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
    } catch (err) {
      console.error('Error decoding HTML:', err);
    }
  };

  const [downloadDocument] = useLazyQuery(get_document_by_docid, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      const documentData = data?.getQuotesInformation;
      let source;
      let fileType = 'htm';
      fileType = documentData.filetype;
      switch (fileType) {
        case 'pdf':
          source = b64toBlobURL(documentData.contents, 'application/pdf');
          download(source);
          break;
        case 'htm':
          openHtmlContent(documentData.contents);
          break;
        default:
          throw new Error(`Invalid file type: ${fileType}`);
      }
    },
    onError: error => {
      console.log('Error Reason: ', error.message);
    }
  });

  return (
    <Box>
      <DocumentsInfoPage
        isLoading={loading}
        error={error}
        accountNumber={accountNumber}
        information={items}
        policies={policies}
        downloadDocument={downloadDocument}
      />
    </Box>
  );
};
